module.exports = __webpack_public_path__ + "static/img/ys1.ec90b33.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/control2/ys1.png
// module id = tawa
// module chunks = 7